import { createContext, useContext, useState } from 'react'

const OnboardingContext = createContext()

export const OnboardingProvider = ({ children }) => {
  const [workJourneyValues, setWorkJourneyValues] = useState('')
  const [availableShift, setAvailableShift] = useState([])
  const [sleepTime, setSleepTime] = useState(null)
  const [awakeTime, setAwakeTime] = useState(null)
  const [caffeineProducts, setCaffeineProducts] = useState([])
  const [selectedCaffeineOptions, setSelectedCaffeineOptions] = useState([])
  const [caffeineTime, setCaffeineTime] = useState(null)

  return (
    <OnboardingContext.Provider
      value={{
        workJourneyValues,
        setWorkJourneyValues,
        availableShift,
        setAvailableShift,
        caffeineProducts,
        setCaffeineProducts,
        selectedCaffeineOptions,
        setSelectedCaffeineOptions,
        sleepTime,
        setSleepTime,
        awakeTime,
        setAwakeTime,
        caffeineTime,
        setCaffeineTime,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  )
}

export const useOnboarding = () => {
  return useContext(OnboardingContext)
}
